import { render } from "./v-button.vue?vue&type=template&id=2d052cd3&lang=true"
import script from "./v-button.vue?vue&type=script&lang=js"
export * from "./v-button.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__